import store         from '@/store/store.js'
import socket        from '@/services/socket.js'
import analytics     from '@/services/analytics.js'
import TimersManager from '@/services/timers.js'

import { bootstrap } from '@/services/bootstrap/bootstrap.js'
import { fingerprint, userOS } from '@/services/utils.js'
import { source } from '@/constants/source'

const OS = userOS()

export const login = (email, password) => {
  return new Promise((resolve, reject) => {
    let action = '/authenticate/parent'

    socket.emit(action, {
      action,
      body: {
        email: email,
        password: password,
        brand_id: 1,
        source
      }
    }, (error, data) => {
      if (error) {
        reject(error)
      } else {
        let authenticated = data && data.is_authenticated

        if (authenticated) {
          let user = {
            ...data.users[0],
            hasPaidLicense: false,
            deviceID: fingerprint(),
            auth_id: data.auth_id
          }

          store.dispatch('auth/setIsAuthenticated', true)
          store.dispatch('auth/setCurrentUser', user)
          store.dispatch('auth/setHasPaidLicense', user.group_id)

          analytics.setUserId(user.id)
          analytics.setUserName(user.name)
          analytics.setDeviceId(user.deviceID)

          if (OS === 'Windows' || OS === 'Linux') {
            analytics.setUserCustomAttribute('ParentSignedInPCDashboard', true)
          }

          if (OS === 'Mac') {
            analytics.setUserCustomAttribute('ParentSignedInMacDashboard', true)
          }

          bootstrap().then(() => {
            resolve({ authenticated, data })
          })
        }
      }
    })
  })
}

export const logout = () => {
  TimersManager.clearTimers()

  store.dispatch('auth/setIsAuthenticated', false)
  store.dispatch('auth/setCurrentUser', null)

  store.dispatch('feed/resetState')
  store.dispatch('children/resetState')
  store.dispatch('categories/resetState')

  localStorage.removeItem('socketCluster.authToken')
}

export const authenticated = () => {
  return store.getters['auth/isAuthenticated']
}

export const user = () => {
  return store.getters['auth/currentUser']
}
